<script setup>
import {Head, usePage} from "@inertiajs/inertia-vue3";
import {computed, defineProps, onBeforeUnmount, onMounted, ref, watch} from "vue";
import useUtils from '../Composables/useUtils';
// import useAuditorio from "../Composables/useAuditorio";
import AuditorioLayoutV2 from "../Layouts/AuditorioLayoutV2";
import { useQuasar } from "quasar";
import { Inertia } from "@inertiajs/inertia";
import useRotas from "../Composables/useRotas";
import { useAuditorioStore } from "@/Stores/auditorioStore";
// import useLoteLocalComUpdatesV2 from "@/Composables/useLoteLocalComUpdatesV2";
import useLote from "@/Composables/useLote";
import LanceV2 from "@/Componentes/Leilao/LanceV2";
import useGlobals from "@/Composables/useGlobals";
import BotaoChat from "@/Componentes/Cabecalho/Partes/Principal/BotaoChat";
import HabilitacaoExtra from "@/Componentes/Leilao/HabilitacaoExtra.vue";


const auditorioStore = useAuditorioStore();

const route = useRotas();

const $q = useQuasar();

const { usernameLogado, emAnalise } = useGlobals();

const props = defineProps({
    leilao: Object,
    loteSelecionadoInit: Object,
    lotesInit: Array,
    // habilitado: Boolean,
    habilitacoesLeilao: Array,
    habilitacoesExtraLeilao: Array,
    idsHabilitacoesClienteAprovadas: Array,
    idsHabilitacoesClienteVerificando: Array,
    idsHabilitacoesClienteReprovadas: Array,
    idsHabilitacoesCliente: Array,
    statusHabilitacaoLeilao: Object,
    idsHabilitacoesExtraClienteAprovadas: Array,
    idsHabilitacoesExtraClienteVerificando: Array,
    idsHabilitacoesExtraClienteReprovadas: Array,
    idsHabilitacoesExtraCliente: Array,
    statusHabilitacaoExtraLeilao: Object,
    documentosRequeridos: Array,
    documentosRequeridosExtra: Array,
});

const habilitado = ref(0);

const autenticado = computed(() => usePage().props.value.auth.autenticado)

const lanceLocalAutomatico = ref(false);
const lanceAutomatico = ref([]);
const temLanceAtomatico = ref(false);
const lanceLocal = ref(false);
const habilitandoLocal = ref(false);

const idLoteSelecionado = computed(() => auditorioStore.idLoteSelecionadoLeilao[props.leilao.id]);
const lote = computed(() => auditorioStore.lotes[idLoteSelecionado.value]);
const loteSelecionadoAuditorio = computed(() => auditorioStore.lotes[idLoteSelecionado.value]);
const listaLotes = computed(() => auditorioStore.lotes);
const listaLotesOrdenados = computed(() => (Object.values(listaLotes.value || {})).filter(lote => +lote.id_leilao === +props.leilao.id).sort((a, b) => a.sequencia - b.sequencia));

const leilaoSelecionadoAuditorio = computed(() => auditorioStore.leiloes[props.leilao.id]);

const atualizarLanceAutomatico = async () => {
    lanceAutomatico.value = await (
        await fetch(
            route("auditorio.temLanceAutomatico", { idLote: loteSelecionadoAuditorio.value.id })
        )
    ).json();
    temLanceAtomatico.value = lanceAutomatico.value.tem_lance_automatico;
};

const carregandoHabilitacao = ref(1);
let atualizarHabilitacao = async () => {

    if (!leilaoSelecionadoAuditorio.value || !loteSelecionadoAuditorio.value) return;
    habilitado.value = 0;
    carregandoHabilitacao.value = 1;
    habilitado.value =
        await(
            await fetch(
                route("auditorio.habilitado", { idLeilao: leilaoSelecionadoAuditorio.value.id, idLote: loteSelecionadoAuditorio.value.id })
                , {
                method: "GET",
                credentials: "include",
            })
        ).json();

    carregandoHabilitacao.value = 0;

};

const seguirLeiloeiro = ref(true);

const valorLanceAtual = computed(() => {
    return loteSelecionadoAuditorio?.value?.lanceAtual;
});

const valorLanceAtualLances = computed(() => {
    return loteSelecionadoAuditorio?.value?.lances?.[0]?.valor;
});

const { autoplay, slide, timerModerador, lanceProprio } = useLote(
    leilaoSelecionadoAuditorio.value,
    lote
);

const {
   formatDate,
    formatador,
    formatadorLote,
    getImagem
} = useUtils();

// 400 mobile, 600 desktop
const larguraImagemCarrossel = computed(() => {
    if ($q.screen.lt.md) {
        return 400;
    }
    return 600;
});

const urlImagemCarrossel = (arquivo) => {
    return getImagem(
        arquivo,
        larguraImagemCarrossel.value,
        loteSelecionadoAuditorio.value?.status_lote?.identificador
    );
};

let leiloeiroAndou = (e) => {
    if (seguirLeiloeiro.value) {

        // SOLUÇÃO THUNDERING HERD: Usa os dados do payload do WebSocket diretamente,
        // ao invés de fazer fetch HTTP para dadosLoteMomentoAuditorio.
        // Antes: 300 usuários faziam 300 GETs simultâneos no servidor ao trocar de lote.
        // Agora: Os dados do lote novo já vêm no broadcast do WebSocket — 0 requisições HTTP.
        if (e.dados && e.dados.id) {
            auditorioStore.carregarLoteDoWebSocket(e.dados);
        } else {
            // Fallback: se o payload do WebSocket não trouxer os dados (cenário defensivo),
            // recorre ao fetch HTTP (que agora está cacheado no Redis por 2s no backend).
            auditorioStore.carregamentoLoteMomentoInicial(leilaoSelecionadoAuditorio.value?.id, e.id);
        }

        slide.value = 1; // volta a imagem para a primeira
        lanceLocal.value = false;
        lanceLocalAutomatico.value = false;

        // Registra listeners de status/update para o novo lote
        window.Echo.channel('realtime.status.lote')
            .listen('.lote.' + e.id + '.status.atualizado', (ev) => {
                callbackStatus(ev);
            });

        window.Echo.channel('realtime.update.lote')
            .listen('.lote.' + e.id + '.atualizado', (ev) => {
                callbackUpdate(ev);
            });

        setTimeout(() => {
            document.querySelector('.list-parent').scrollLeft = document.querySelector('.list-parent > .atual').offsetLeft - 20
        }, 800);

    }
};

let leiloeiroMudouLeilao = async (e) => {
    if (+leilaoSelecionadoAuditorio.value?.id === +e.idLeilaoAnterior) {
        if (seguirLeiloeiro.value) {

            Inertia.visit(route('auditorio.auditorioV2', {
                idLeilao: e.idLeilao
            }));

        }
    }

};

let callbackStatus = (e) => {
    auditorioStore.enfileirar(e);
}

let callbackUpdate = (e) => {
    auditorioStore.enfileirar(e);
}

onMounted(async () => {

    $q.loading.show({
        message:
            "<p>Carregando Auditorio</p>",
        html: true,
    });
    setTimeout(() => {
        $q.loading.hide();
    }, 3000);

    await auditorioStore.carregamentoLeilaoInicial(props.leilao.id);
    await auditorioStore.carregamentoLotesInicial(props.leilao.id);

    if(!idLoteSelecionado.value){
        await abrirLoteAuditorio(props.loteSelecionadoInit.id);
    }

    auditorioStore.processarFila()

    window.Echo.channel("realtime.status.leilao").listen(
        ".leilao." + props.leilao.id + ".status.atualizado",
        (e) => {
            callbackStatus(e);
        }
    );

    window.Echo.channel("realtime.update.leilao").listen(
        ".leilao." + props.leilao.id + ".atualizado",
        (e) => {
            callbackUpdate(e);
        }
    );

    window.Echo.channel("auditorio." + props.leilao.id).listen(
        ".leiloeiroAndou",
        (e) => {
            leiloeiroAndou({ id: e.novoLote, dados: e.dadosNovoLote });
        }
    );

    window.Echo.channel("auditorio").listen(".leiloeiroMudouLeilao", (e) => {
        leiloeiroMudouLeilao({
            idLeilao: e.novoLeilao,
            idLeilaoAnterior: e.leilaoAnterior,
        });
    });

});

const urlVideo = computed(() => {
    return leilaoSelecionadoAuditorio.value?.link_transmissao
        ? `${leilaoSelecionadoAuditorio.value?.link_transmissao}`
        : null;
});

const abrirLoteAuditorio = (idLote) => {

    auditorioStore.carregamentoLoteMomentoInicial(leilaoSelecionadoAuditorio.value?.id,idLote);
    slide.value = 1; // volta a imagem para a primeira

    lanceLocal.value = false;
    lanceLocalAutomatico.value = false;



    window.Echo.channel('realtime.status.lote')
        .listen('.lote.' + idLote + '.status.atualizado', (e) => {
            callbackStatus(e);
        });

    window.Echo.channel('realtime.update.lote')
        .listen('.lote.' + idLote + '.atualizado', (e) => {
            callbackUpdate(e);
        });

};

const valorLanceAuditorio = ref(0);

const abrindoLance = (valorLance) => {
    valorLanceAuditorio.value = valorLance;
    lanceLocal.value = true;
};

const abrindoLanceAutomatico = (valorLance) => {
    valorLanceAuditorio.value = valorLance;
    lanceLocalAutomatico.value = true;
};

const voltarPaginaLeilao = () => {
    Inertia.visit(route('leilao', {
        idLeilao: leilaoSelecionadoAuditorio.value?.id
    }));
}

const decodeHtmlEntities = (text) => {
    const entities = {
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&amp;": "&",
    };
    return text.replace(/&lt;|&gt;|&quot;|&amp;/g, (match) => entities[match]);
};
const replaceHmtlIframe = (encodedHtml) => {
    let decodedHtml = encodedHtml;

    if (decodedHtml && decodedHtml.length > 0) {
        const arrayRegex = [
            /&lt;iframe\s+src="https:\/\/www\.google\.com\/maps\/embed[^"]*"[^&]*&gt;&lt;\/iframe&gt;/g,
            /&lt;iframe[^>]*\bsrc="https:\/\/www\.youtube\.com\/embed\/[^"]*"[^>]*&gt;&lt;\/iframe&gt;/g,
        ];

        arrayRegex.forEach((e) => {
            decodedHtml = decodedHtml.replace(e, (match) =>
                decodeHtmlEntities(match)
            );
        });
    }

    return decodedHtml;
};

const descricaoLote = computed(() => replaceHmtlIframe(loteSelecionadoAuditorio.value?.descricao));

watch([valorLanceAtual, valorLanceAtualLances], ([newValorLanceAtual], [oldValorLanceAtual]) => {

    if(newValorLanceAtual !== oldValorLanceAtual){
        valorLanceAuditorio.value = +loteSelecionadoAuditorio?.value?.proximoLance;
    }

});

watch(idLoteSelecionado, (newValue, oldValue) => {

    if (newValue !== oldValue) {
        atualizarHabilitacao();
    }

});

onBeforeUnmount(() => {
    auditorioStore.pararFila();
    leiloeiroAndou = () => {};
    leiloeiroMudouLeilao = () => {};

    callbackStatus = () => {};
    callbackUpdate = () => {};
    auditorioStore.redefinirLoteSelecionado(props.leilao.id);
});

</script>
<template>
    <Head :title="'Auditorio - ' + loteSelecionadoAuditorio?.titulo" />
    <AuditorioLayoutV2>
        <q-page class="flex column bg-grey-3">
            <div class="full-width flex row justify-between items-center bg-primary" style="border-bottom: 5px solid rgb(194, 0, 11); height: 50px;">
                <div class="full-height q-mx-md flex column justify-center">
                    <span
                        class="q-ma-none text-white text-subtitle1"
                        :class="$q.screen.gt.sm ? '' : 'text-subtitle2'"
                    >
                        <q-btn outline size="sm" class="q-mr-sm" @click="voltarPaginaLeilao">
                            <q-icon name="mdi-arrow-left" />
                        </q-btn>

                        <template v-if="leilaoSelecionadoAuditorio">
                            Data: {{ formatDate(leilaoSelecionadoAuditorio?.data_hora_inicio) }}
                            -
                            Leilão:
                            {{ leilaoSelecionadoAuditorio?.id }} "{{
                                    leilaoSelecionadoAuditorio?.titulo
                                }}"
                        </template>

                    </span>
                </div>
                <div class="full-height q-mr-md flex row justify-center text-white">
                    <botao-chat v-if="autenticado"/>

                    <q-toggle
                        :true-value="true"
                        :false-value="false"
                        v-model="seguirLeiloeiro"
                        label="Seguir Leiloeiro"
                        color="white"
                    />
                </div>
            </div>

            <div class="col-12 row bg-grey-3" >

                <div class="col-12 q-px-sm q-mt-sm ">
                    <q-card class="q-px-md q-py-sm">
                        <div class="text-subtitle3 text-primary flex justify-between">
                            <span>Lotes</span>
                            <span class="text-caption">Legenda: <q-icon name="mdi-checkbox-blank" style="color: #BFD13B;"/> Vendido
                                - <q-icon name="mdi-checkbox-blank" style="color: #FF0000;"/> Não Vendido
                                - <q-icon name="mdi-checkbox-blank" style="color: #DB7313;"/> Condicional</span>
                        </div>

                        <div class="full-width flex no-wrap list-parent" style="overflow-x: auto">
                            <q-btn v-for="lote in listaLotesOrdenados"
                                   :key="lote.id"
                                   class="q-my-xs q-ml-none q-mr-sm"
                                   :unelevated="!(lote.id === loteSelecionadoAuditorio?.id)"
                                   square
                                   dense
                                   @click="abrirLoteAuditorio(lote.id)"
                                   style="width: 35px; height: 35px; flex-shrink: 0"
                                   :class="
                                lote.id === loteSelecionadoAuditorio?.id
                                    ? `atual card-${lote.id}`
                                    : `card-${lote.id}`
                            "
                                   :style="`
                             color: white;
                             background-color: ${lote?.status_lote?.cor_site || '#00000073'};
                             transform: ${
                                 lote.id === loteSelecionadoAuditorio?.id ? 'scale(1);' : 'scale(1);'
                             }
                             ${lote.id === loteSelecionadoAuditorio?.id ? 'border: solid 3px #00000073;' : ''}
                             ${lote.id === loteSelecionadoAuditorio?.id ? '' : 'opacity: 0.95;'}
                             `"
                            >
                                {{ lote.sequencia }}
                            </q-btn>
                        </div>

                    </q-card>




                </div>

                <div class="flex row full-width" :style="$q.screen.lt.md ? 'flex-direction: column-reverse' : '' ">
                    <div class="bg-grey-3 row q-py-sm q-pl-sm q-pr-none"
                         :class="$q.screen.lt.md ? 'col-12' : 'col-8' "
                    >
                        <div class="col-12 row">
                            <div class="bg-grey-3 q-pr-sm" :class="$q.screen.lt.md ? 'col-12' : 'col-6'">
                                <q-card class="col-12">
                                    <q-card-section class="q-pa-none q-mb-xs flex row ">
                                        <q-carousel
                                            class="override-index full-width"
                                            v-model="slide"
                                            :autoplay="false"
                                            animated
                                            arrows

                                            control-color="white"
                                            control-text-color="primary"
                                            control-type="push"
                                            next-icon="mdi-chevron-right"
                                            prev-icon="mdi-chevron-left"
                                            infinite
                                            swipeable
                                            :class="$q.screen.gt.sm ? 'col-5' : 'col-12'"
                                            @mouseenter="autoplay = false"
                                            @mouseleave="autoplay = true"
                                        >
                                            <q-carousel-slide
                                                v-for="(imagem, key) in lote?.imagens_lote &&
                            loteSelecionadoAuditorio?.imagens_lote.length > 0
                                ? loteSelecionadoAuditorio?.imagens_lote
                                : leilaoSelecionadoAuditorio?.comitente?.arquivo_capa_padrao
                                ? [
                                      {
                                          arquivo:
                                              leilaoSelecionadoAuditorio?.comitente?.arquivo_capa_padrao,
                                      },
                                  ]
                                : []"
                                                :key="key"
                                                :name="
                                1 + key
                            "
                                                style="
                                background-position: center;
                                background-size: cover;
                                background-repeat: no-repeat;
                            "
                                                class="q-pa-none"
                                            >
                                                <q-img
                                                    class="full-width full-height"
                                                    :loading="key === 0 ? 'eager' : 'lazy'"
                                                    :src="urlImagemCarrossel(imagem?.arquivo)"
                                                    :ratio="16 / 9"
                                                >
                                                    <template v-slot:error>
                                                        <div
                                                            class="absolute-full flex flex-center bg-primary text-white"
                                                        >
                                                            Houve um problema carregando a imagem
                                                        </div>
                                                    </template>
                                                    <template v-slot:loading>
                                                        <div
                                                            class="absolute-full flex column flex-center bg-white text-primary"
                                                        >
                                                            <img
                                                                :src="logoLeiloeiro"
                                                                style="width: 40%"
                                                            />
                                                            <p class="q-mt-sm">
                                                                <q-spinner size="sm" class="q-pr-sm" />
                                                                Carregando imagem...
                                                            </p>
                                                        </div>
                                                    </template>
                                                </q-img>
                                            </q-carousel-slide>
                                        </q-carousel>
                                    </q-card-section>
                                </q-card>
                                <div class="col-12">
                                    <q-card class="q-mt-sm">
                                        <q-card-section>
                                            <div class="text-subtitle1 text-primary">Últimos Lances</div>
                                        </q-card-section>
                                        <q-card-section v-if="!(+loteSelecionadoAuditorio?.lances?.length > 0)" style="font-size: 10px;">
                                            Nenhum lance registrado.
                                        </q-card-section>
                                        <q-card-section class="q-pt-none" v-else>
                                            <q-scroll-area
                                                class="full-width"
                                                style="height: 150px; "
                                            >
                                                <div class="q-pa-none full-width" >
                                                    <q-markup-table>
                                                        <thead>
                                                        <tr style="height: auto;">
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Lance</th>
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Apelido</th>
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Valor</th>
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Data e Hora</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr v-for="(lance, idx) in loteSelecionadoAuditorio?.lances" :key="idx" style="height: auto;">
                                                                <td class="text-left" style="height: auto; font-size: 10px;"><q-icon name="mdi-cash" :color=" (+idx === 0) ? 'secondary' : 'primary'" size="20px"/></td>
                                                                <td class="text-left" style="height: auto; font-size: 10px;">{{ (+leilaoSelecionadoAuditorio?.mostrar_apelido === 0) ? lance?.cliente?.id : lance?.cliente?.usuario?.username}}</td>
                                                                <td class="text-left" style="height: auto; font-size: 10px;">{{ formatador.format(lance?.valor) }}</td>
                                                                <td class="text-left" style="height: auto; font-size: 10px;">{{formatDate(lance?.data_hora)}}</td>
                                                            </tr>

                                                        </tbody>
                                                    </q-markup-table>
                                                </div>
                                            </q-scroll-area>
                                        </q-card-section>

                                    </q-card>
                                </div>
                                <div class="col-12">
                                    <q-card class="q-mt-sm">
                                        <q-card-section>
                                            <div class="text-subtitle1 text-primary">Meus Últimos Lances</div>
                                        </q-card-section>
                                        <q-card-section v-if="!(+loteSelecionadoAuditorio?.lances?.length > 0)" style="font-size: 10px;">
                                            Nenhum lance registrado por você.
                                        </q-card-section>
                                        <q-card-section class="q-pt-none" v-else>
                                            <q-scroll-area
                                                class="full-width"
                                                :thumb-style="thumbStyle"
                                                :bar-style="barStyle"
                                                style="height: 100px; "
                                            >
                                            <div class="q-pa-none full-width">
                                                <q-markup-table>
                                                    <thead>
                                                        <tr style="height: auto;">
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Apelido</th>
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Valor</th>
                                                            <th class="text-left text-bold" style="height: auto; font-size: 10px;">Data e Hora</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <template  v-for="(lance, idx) in loteSelecionadoAuditorio?.lances" :key="idx">
                                                        <tr style="height: auto;" v-if="lance?.cliente?.usuario?.username === usernameLogado">
                                                            <td class="text-left" style="height: auto; font-size: 10px;">{{lance?.cliente?.usuario?.username}}</td>
                                                            <td class="text-left" style="height: auto; font-size: 10px;">{{ formatador.format(lance?.valor) }}</td>
                                                            <td class="text-left" style="height: auto; font-size: 10px;">{{formatDate(lance?.data_hora)}}</td>
                                                        </tr>
                                                    </template>

                                                    </tbody>
                                                </q-markup-table>
                                            </div>
                                            </q-scroll-area>
                                        </q-card-section>

                                    </q-card>
                                </div>
                            </div >
                            <q-card class=" q-pa-md" :class="$q.screen.lt.md ? 'col-12' : 'col-6'">
                                <div class="text-primary text-subtitle1">Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia) }}</div>
                                <div class="text-primary text-h6">{{ loteSelecionadoAuditorio?.titulo }}</div>
                                <q-separator class="q-my-md"/>
                                <div class="text-primary">Descrição:</div>
                                <div v-html="descricaoLote"> </div>
                            </q-card>
                        </div>

                    </div>

                    <div class="bg-grey-3 q-pa-sm"
                         :class="$q.screen.lt.md ? 'col-12' : 'col-4' ">
                        <div class="col-12 q-mb-sm" v-if="loteSelecionadoAuditorio?.sequencia && $q.screen.lt.md">
                            <q-card>
                                <q-card-section class="text-center text-subtitle1 text-primary">
                                    Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia || 0 )  }}
                                </q-card-section>
                            </q-card>
                        </div>
                        <KeepAlive :key="urlVideo">
                            <div class="col-12"  v-if="urlVideo" v-show="+leilaoSelecionadoAuditorio?.transmissao_iniciada === 1">
                                <q-card >
                                    <q-card-section class="q-pb-none">
                                        <div class="text-subtitle1 text-primary">Ao Vivo</div>
                                    </q-card-section>
                                    <q-card-section>
                                        <q-video

                                            :ratio="16/9"
                                            :src="urlVideo"
                                        />
                                    </q-card-section>
                                </q-card>
                            </div>
                        </KeepAlive>
                        <div class="col-12" v-if="+leilaoSelecionadoAuditorio?.fechamento_automatico === 0 &&
                                loteSelecionadoAuditorio?.timer_moderador && timerModerador">
                            <q-card class="q-mt-sm text-primary"

                            >
                                <q-card-section>
                                    <div class="text-h6 text-center"><q-icon name="mdi-timer" color="primary" size="sm" class="q-mr-md"/>{{timerModerador}}</div>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12 ">
                            <q-card class="q-mt-sm"
                                    :style="`background-color: ${loteSelecionadoAuditorio?.status_lote?.cor_site};`"
                                    style="color: white;"
                            >
                                <q-card-section class="q-ma-none q-pa-xs">
                                    <div class="text-h6 text-center">{{loteSelecionadoAuditorio?.status_lote?.nome}}</div>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12" v-if="loteSelecionadoAuditorio">
                            <q-card class="q-mt-sm">
                                <q-card-section>
                                    <template v-if="loteSelecionadoAuditorio?.lances?.[0]?.valor">
                                        <div class="text-h6 text-primary">Lance Atual: {{formatador.format(loteSelecionadoAuditorio?.lances?.[0]?.valor || valorLanceAtual)}}</div>
                                        <div class="text-subtitle3">
                                            Por
                                            <span v-if="loteSelecionadoAuditorio?.lances?.[0]?.cliente?.usuario?.username === usernameLogado" class="text-primary">você</span>
                                            {{ (+leilaoSelecionadoAuditorio?.mostrar_apelido === 0) ? loteSelecionadoAuditorio?.lances?.[0]?.cliente?.id : loteSelecionadoAuditorio?.lances?.[0]?.cliente?.usuario?.username}}
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="text-h6 text-primary">Lance Inicial: {{formatador.format(
                                            leilaoSelecionadoAuditorio?.primeiro_leilao_concluido === 1 && +leilaoSelecionadoAuditorio?.dois_leiloes === 1
                                                ? loteSelecionadoAuditorio?.lance_inicial_segundo_leilao
                                                : loteSelecionadoAuditorio?.lance_inicial
                                        )}}</div>
                                    </template>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12">
                            <q-card class="q-mt-sm">
                                <q-card-section class="flex justify-between">
                                    <div>
                                        <div class="text-subtitle1 text-primary">Dê seu lance</div>
                                        <div class="text-subtitle3" v-if="loteSelecionadoAuditorio?.incremento">Incremento: {{formatador.format(loteSelecionadoAuditorio?.incremento)}}</div>
                                    </div>
                                    <div>
                                        <q-btn
                                            v-if="
                                            habilitado &&
                                            !emAnalise &&
                                            !lanceProprio &&
                                            [
                                                'ABERTO',
                                                'EM PREGAO',
                                                'DOULHE_UMA',
                                                'DOULHE_DUAS',
                                                'PROPOSTA_UMA',
                                                'PROPOSTA_DUAS',
                                                'REPASSE',
                                                'CONDICIONAL_REABERTA',
                                            ].includes(
                                                loteSelecionadoAuditorio?.status_lote?.identificador
                                            ) &&
                                            ['ABERTO', 'EM_PREGAO'].includes(
                                                leilaoSelecionadoAuditorio?.status_leilao?.identificador
                                            ) &&
                                            +leilaoSelecionadoAuditorio?.permitir_lance_automatico === 1
                                        "
                                            class="full-width q-mt-sm hide-print text-primary bg-grey-3"
                                            size="sm"
                                            @click="abrindoLanceAutomatico(+loteSelecionadoAuditorio?.proximoLance)"
                                            label="Configurar Lance Automático"
                                            outline
                                        />
                                    </div>

                                </q-card-section>
                                <q-card-section class="q-pt-none">
                                    <div v-if="emAnalise" class="text-primary">
                                        Seu cadastro está em análise. Não é possível dar lances.
                                    </div>
                                    <div v-else-if="carregandoHabilitacao" class="text-primary">

                                    </div>
                                    <div v-else-if="!['ABERTO', 'EM_PREGAO'].includes(
                                                leilaoSelecionadoAuditorio?.status_leilao?.identificador
                                            )" class="text-primary">
                                        O leilão está {{leilaoSelecionadoAuditorio?.status_leilao?.nome}}
                                    </div>
                                    <div v-else-if="!habilitado">
                                        <q-btn
                                            @click="habilitandoLocal = true"
                                            :class="'bg-primary'"
                                            class="text-white full-width hide-print"
                                            label="Habilite-se para dar seu lance!"
                                        />
                                    </div>
                                    <div v-else-if="
                                         ![
                                    'ABERTO',
                                    'EM PREGAO',
                                    'DOULHE_UMA',
                                    'DOULHE_DUAS',
                                    'PROPOSTA_UMA',
                                    'PROPOSTA_DUAS',
                                    'REPASSE',
                                    'CONDICIONAL_REABERTA',
                                    ].includes(
                                    loteSelecionadoAuditorio?.status_lote?.identificador
                                    )
                                    " class="text-primary">
                                        O lote não está recebendo lances.
                                    </div>
                                    <div v-else-if="
                                         +leilaoSelecionadoAuditorio?.aceita_lances_somente_pj ===
                                                1 &&
                                            +usePage().props.value.auth?.cliente
                                                ?.tipo_pessoa === 0 &&
                                            +loteSelecionadoAuditorio?.vistoria_veicular?.sucata === 1
                                    " class="text-primary">
                                        Lance somente para Pessoa Jurídica (CNPJ).
                                    </div>
                                    <div v-else-if="loteSelecionadoAuditorio?.status_lote?.identificador === 'CONDICIONAL_REABERTA'" class="text-primary">

                                        <div v-if="loteSelecionadoAuditorio?.status_lote?.identificador === 'CONDICIONAL_REABERTA'"
                                             class="q-pa-xs"
                                             :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                            <q-btn
                                                @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance)"
                                                :class="'bg-primary'"
                                                class="text-white hide-print full-width"
                                                :label="'Confirmar Venda (' + formatador.format(+loteSelecionadoAuditorio?.proximoLance) + ')'"
                                            />
                                        </div>

                                    </div>
                                    <div v-else-if="lanceProprio" class="text-primary">
                                        O seu lance está vencendo.
                                    </div>
                                    <div v-else class="flex justify-center row full-width col-12 q-pa-none" >
                                        <template v-if="habilitado">
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                                <q-btn
                                                    @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance)"
                                                    :class="'bg-primary'"
                                                    class="text-white hide-print full-width"
                                                    :label="formatador.format(+loteSelecionadoAuditorio?.proximoLance)"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                                <q-btn
                                                    @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance + +loteSelecionadoAuditorio?.incremento)"
                                                    :class="'bg-primary'"
                                                    class="text-white hide-print full-width"
                                                    :label="formatador.format((+loteSelecionadoAuditorio?.proximoLance + +loteSelecionadoAuditorio?.incremento))"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                                <q-btn
                                                    @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 2))"
                                                    :class="'bg-primary'"
                                                    class="text-white hide-print full-width"
                                                    :label="formatador.format((+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 2)))"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                                <q-btn
                                                    @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 3))"
                                                    :class="'bg-primary'"
                                                    class="text-white hide-print full-width"
                                                    :label="formatador.format((+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 3)))"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                                <q-btn
                                                    @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 4))"
                                                    :class="'bg-primary'"
                                                    class="text-white hide-print full-width"
                                                    :label="formatador.format((+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 4)))"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-4'">
                                                <q-btn
                                                    @click="abrindoLance(+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 5))"
                                                    :class="'bg-primary'"
                                                    class="text-white hide-print full-width"
                                                    :label="formatador.format((+loteSelecionadoAuditorio?.proximoLance + (+loteSelecionadoAuditorio?.incremento * 5)))"
                                                />
                                            </div>
                                        </template>
                                    </div>

                                </q-card-section>

                            </q-card>
                        </div>
                    </div>
                </div>
            </div>

            <habilitacao-extra
                v-model="habilitandoLocal"
                :leilao="leilaoSelecionadoAuditorio"
                :lote="loteSelecionadoAuditorio"
                :habilitado="habilitado"
                :habilitacoesLeilao="habilitacoesLeilao"
                :habilitacoesExtraLeilao="habilitacoesExtraLeilao"
                :idsHabilitacoesClienteAprovadas="idsHabilitacoesClienteAprovadas"
                :idsHabilitacoesClienteVerificando="
                idsHabilitacoesClienteVerificando
            "
                :idsHabilitacoesClienteReprovadas="idsHabilitacoesClienteReprovadas"
                :idsHabilitacoesCliente="idsHabilitacoesCliente"
                :statusHabilitacaoLeilao="statusHabilitacaoLeilao"
                :idsHabilitacoesExtraClienteAprovadas="
                idsHabilitacoesExtraClienteAprovadas
            "
                :idsHabilitacoesExtraClienteVerificando="
                idsHabilitacoesExtraClienteVerificando
            "
                :idsHabilitacoesExtraClienteReprovadas="
                idsHabilitacoesExtraClienteReprovadas
            "
                :idsHabilitacoesExtraCliente="idsHabilitacoesExtraCliente"
                :statusHabilitacaoExtraLeilao="statusHabilitacaoExtraLeilao"
                :documentosRequeridosExtra="documentosRequeridosExtra"
                :documentosRequeridos="documentosRequeridos"
                origem="auditorio-v2"
            />
            <LanceV2 v-if="loteSelecionadoAuditorio?.id"
                v-model="lanceLocal"
                :leilao="leilaoSelecionadoAuditorio"
                :lote="loteSelecionadoAuditorio"
                :valor-lance="valorLanceAuditorio"
                :habilitado="habilitado"
                :automatico="false"
            />
            <LanceV2 v-if="loteSelecionadoAuditorio?.id"
                     v-model="lanceLocalAutomatico"
                     :leilao="leilaoSelecionadoAuditorio"
                     :lote="loteSelecionadoAuditorio"
                     :valor-lance="valorLanceAuditorio"
                     :habilitado="habilitado"
                     :automatico="true"
                     :lanceAutomatico="lanceAutomatico"
                     :lanceProprio="lanceProprio"
                     @atualizacaoLanceAutomatico="atualizarLanceAutomatico"
            />
        </q-page>
    </AuditorioLayoutV2>
</template>
<style scoped>

    ::-webkit-scrollbar {
        right: 0;
        border-radius: 5px;
        background-color: transparent;
        height: 10px;
        opacity: 0.5;
    }

    ::-webkit-scrollbar-thumb {
        cursor: pointer;
        border-radius: 9px;
        background: rgba(0, 0, 0, 0.15);
    }

</style>
